import React from "react";
import logo from "../Asset/logo.png";
import twent24 from "../Asset/24-7.png";
import milestone from "../Asset/IHM-Milestone.jpg";
import ihmfooter from "../Asset/ihm_footer.png";
import sideImg from "../Asset/744.jpg";
import AuthService from "../Authentication/AuthService";
import "../Asset/css/staticDashboard.css";

class StaticDashboard extends React.Component {
  authService;
  constructor(props) {
    super(props);
    this.authService = new AuthService();
    this.state = {
    };
  }
  componentDidMount() {
    window.location.href = process.env.REACT_APP_PRODUCTS_PAGE_ENDPOINT;

  }

  // login = () => {
  //   this.props.history.push('/login');
  // }

  render() {
    return (
      <div></div>
      // <div className="row">
      //   <div className="col-sm-12 col-md-12">
      //     <div className="app-header" style={{ borderBottom: "none" }}>
      //       <div className="site-header-inner my-1">
      //         <div className="row wid100 ml-0" style={{ maxWidth: '100%', flex: '0 0 100%' }}>
      //           <div className="col-sm-6 col-md-6">
      //             <a href="#" style={{ padding: "0.5rem 1rem" }}>
      //               <img className="logo-image" src={logo}></img>
      //             </a>
      //           </div>
      //           <div className="col-sm-6 col-md-6 text-right">
      //             <div className="mt-2">
      //               <button className="btn btn-primary my-2 my-sm-0" type="submit" onClick={() => this.login()}>Login</button>
      //             </div>
      //           </div>
      //         </div>
      //       </div>
      //     </div>
      //     <div className="wrap min-ht">
      //       <div className="wrap-sub">
      //         <div className="wrap">
      //           <div className="col-12 col-sm-8 pull-left customStyle">
      //             <h1 style={{ textAlign: "left", color: "silver" }}>IHM</h1>
      //           </div>
      //           <div className="col-12 col-sm-4 pull-right">
      //             <div className="wrap">
      //               <div className="col-3" style={{ marginLeft: "-15px" }}><img src={twent24} className="img-fluid" alt="" /></div>
      //               <div className="col-9 vercent customStyle">
      //                 <p style={{ fontSize: "16px", color: "whitesmoke", padding: "0", margin: "0" }}><strong>24x7 Technical Support</strong></p>
      //                 <p className="copytext" style={{ fontSize: "14px", color: "whitesmoke", lineHeight: "18px" }}>Email: <a href="mailto:technical@marinemechanics.biz">technical@marinemechanics.biz</a><br />
      //                      Phone : +91  7810012222
      //                 </p>
      //               </div>
      //             </div>
      //           </div>
      //         </div>
      //       </div>
      //       <div className="wrap cpad25">
      //         <div className="wrap cpad25 border-bot">
      //           <div className="col-sm-4 wow fadeInUp"><img src={sideImg} className="img-fluid" alt="" /></div>
      //           <div className="col-sm-8 wow fadeInUp customStyle">
      //             <h3>Inventory of Hazardous Materials - IHM</h3>
      //             <p><strong>MMPL</strong> has a strong team of <strong>DNV-GL trained IHM experts</strong> who can handle IHM for both new builds and existing ships in a professional manner.</p>
      //             <p>Below script will give a <strong>brief description of IHM</strong>, <strong>background</strong>, <strong>process of obtaining the IHM for your ships</strong>.</p>
      //             <h3>Back Ground of IHM</h3>
      //             <p>From the mid-1980s, the center of the ship scrapping industry shifted towards Asia, in particular to India, Bangladesh and Pakistan. This industry was, and still is, virtually unregulated and has one of the worst safety records of any industry. It also causes massive environmental pollution. Initially, there was little awareness or acknowledgement of the appalling working conditions and environmental pollution. However, a concerted campaign by environmental groups has brought about widespread awareness of ship scrapping practices.</p>
      //             <p>In order to address these issues, industry working groups developed the Industry Code of Practice on Ship Recycling. This guidance subsequently fed into discussions at the International Maritime Organization (IMO), which resulted in the IMO Guidelines on Ship Recycling, adopted by member states in December 2003. These voluntary guidelines introduced the concept of a &lsquo;Green Passport&rsquo; Inventory for the first time. In parallel with this activity, the International Labor Organization (ILO) developed Guidelines on Safety and Health in Ship Breaking in Asia and Turkey and the Basel Convention published guidance on Environmentally Sound Management of Dismantling of Ships. The pre- existing Basel Convention on the Transboundary Movement of Hazardous Wastes also began to be applied to ships, although it was not originally intended for this purpose.</p>
      //             <p>Further, IMO adopted &ldquo;The Hong Kong International Convention for the safe of environmentally sound recycling of ships&rdquo; in the year 2009 followed by the EU Ship Recycling Regulation (EU SRR) in 2013 that requires every ship calling at EU Port to carry an inventory of hazardous material (IHM) verified by the relevant administration or authority and specifying the location and approximate quantities of those materials</p>
      //             <h3>What is an Inventory of Hazardous Materials</h3>
      //             <p>An IHM (Inventory of Hazardous Material) is a document in which all potentially hazardous material onboard a vessel that can pose a risk to the health and safety of people or to the environment is located, identified and quantified.</p>
      //             <h3>Why do you need IHM</h3>
      //             <p>It is mandatory for all ships larger than 500 ton to keep an IHM. The inventory replaces the Green Passport, adopted in the Hong Kong International Convention in 2009, and is a requirement by the EU Ship Recycling Regulation 2013.</p>
      //             <p>The Hong Kong Convention (HKC) Applicable to vessels of 500 GT of more</p>
      //             <p>EU Regulation 1257 / 2013</p>
      //             <p>Applicable to vessels of 500 GT of more</p>
      //             <p>Adopted by IMO in 2009</p>
      //             <p>Almost same requirements as the HKC</p>
      //             <p>Ship recycling should not pose any unnecessary risk to human health and safety or to the environment</p>
      //             <p>Requires IHM for all vessels calling European ports from 2020</p>
      //             <p>Signed by 10 countries so far</p>
      //             <p>2 new hazardous materials to be checked (PFOS &ndash; for existing&nbsp;ships &amp; HBCDD &ndash; for new built ship) apart from items in Table A and Table B of the Hong Kong Convention.</p>
      //             <p>All potential hazardous material should be listed in IHM documentation</p>
      //             <p>Main items to be listed (asbestos, PCBs, ODS, TBT) from Table A, and others materials from Table B (heavy metals &amp; radioactive substances)</p>
      //             <h3>Application</h3>
      //             <img src={milestone} className="img-fluid" alt="" />
      //             <h3>What is the IHM Process?</h3>
      //             <h5>Preparation of IHM</h5>
      //             <ul>
      //               <li className="customStyle">
      //                 <p>Collection of necessary information and documentation</p>
      //               </li>
      //               <li className="customStyle">
      //                 <p>Preparation, on board visual inspection and sampling check</p>
      //               </li>
      //               <li className="customStyle">
      //                 <p>Collected samples sent for laboratories analysis</p>
      //               </li>
      //               <li className="customStyle">
      //                 <p>IHM prepared by our trained and certified personnel</p>
      //               </li>
      //             </ul>
      //             <h5>Application for Statement of Compliance (SOC)</h5>
      //             <ul>
      //               <li className="customStyle">
      //                 <p>Submission of reports to Class office and request for SOC</p>
      //               </li>
      //               <li className="customStyle">
      //                 <p>Verification survey carried out on board by Class</p>
      //               </li>
      //               <li className="customStyle">
      //                 <p>Basic result of survey and SOC issued by Class upon satisfaction</p>
      //               </li>
      //             </ul>
      //           </div>
      //         </div>
      //       </div>
      //     </div>
      //     <div className="footer p-5">
      //       <div className="row">
      //         <div className="col-xs-12 col-sm-4 copytext" style={{ textAlign: "center" }}>
      //           Copyright &copy; 2018 Marine Mechanics Pvt Ltd  <br /> All Rights Reserved.
      //       </div>
      //         <div className="col-xs-10 col-sm-3 copytext" style={{ textAlign: "center" }}>
      //           Design &amp; Developed by - <a href="http://www.aristowebtek.in"><br /> Aristo Creative Technologies</a>
      //         </div>
      //         <div className="col-xs-2 col-sm-1 copytext" style={{ textAlign: "center" }}>
      //           <a href="/!hm2k!908-27"><img src={ihmfooter} className="img-fluid" target="_blank" alt="ihm" /></a>
      //         </div>
      //         <div className="col-xs-12 col-sm-4" style={{ textAlign: "center" }}>
      //           <a href="https://www.facebook.com/MarineMechanics.biz" target="_blank"><i className="footerIcon fa fa-facebook p-2"> </i></a><a href="https://twitter.com/MechanicsMarine" target="_blank"><i className="footerIcon fa fa-twitter p-2"></i></a><a href="https://www.linkedin.com/company/marine-mechanics-pvt-ltd/" target="_blank"><i className="footerIcon fa fa-linkedin p-2"></i></a><a href="https://www.instagram.com/marinemechanics.biz/" target="_blank"><i className="footerIcon fa fa-comment p-2"></i></a><a href="https://plus.google.com/100366615227246141522" target="_blank"><i className="footerIcon fa fa-google-plus p-2"></i></a><a href="https://www.youtube.com/channel/UCS1tRVE9qIJFo5MhlDxeMig" target="_blank"><i className="footerIcon fa fa-youtube p-2"></i></a><a href="mailto:technical@marinemechanics.biz" target="_parent"><i className="footerIcon fa fa-envelope p-2"></i></a>
      //         </div>
      //       </div>
      //     </div>
      //   </div>
      // </div>
    );
  }
}

export default StaticDashboard;
